import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { ActivatedRoute, Router, } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { QRCode } from "../../forked/qr_code";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import {
  GroupOrderQrCodeDialogComponent,
  SecureCheckDialogComponent,
  WarningdialogComponent,
  AnnounceDialogComponent,
} from "../../modalDialogs";
import { GroupOrderShareService } from "./groupOrderShare.service";
import { Observable } from "rxjs";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { SnackBarMessageType } from "../../shared/contentTypes";
import {
  snackBarMessageKey,
  SnackBarService,
} from "../../services/snackBar.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { AnounceModalResult } from "../../shared/contentTypes";
import { environment } from "../../../../environments/environment";
import { GroupStateService } from "../../services/groupState.service";

@Component({
  selector: "groupOrderShare",
  templateUrl: "./groupOrdershare.component.html",
  styleUrls: ["./groupOrderShare.component.scss"],
  providers: [GroupOrderShareService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupOrderShareComponent implements OnInit, OnDestroy {
  private _langSubscriber: Subscription;
  public isSmallView: boolean = false;
  public inviteQrCodesvg: SafeHtml;
  public groupIsFull$: Observable<boolean>;
  private inviteAFriend: boolean = true;
  private groupCode: string;
  public shownavigatetomenu: boolean;

  constructor(
    private _location: Location,
    private _groupOrderShareService: GroupOrderShareService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _mainnavService: MainnavService,
    private internationalisationService: InternationalisationService,
    private _sanitized: DomSanitizer,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _inHouseOrderService: InHouseOrderService,
    private _snackBarService: SnackBarService,
    private _iosHelperService: IOSHelperService,
    private _groupStateService: GroupStateService,
  ) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error(
        "GroupOrderInviteComponent.PushChanges",
        "_changeDetectorRef.detectChanges (catch)",
        e
      );
    }
  }

  ngOnInit() {
    const me = this;
    me.groupIsFull$ = me._groupOrderShareService.groupIsFull$;
    me.inviteQrCodesvg = me._sanitized.bypassSecurityTrustHtml(
      new QRCode(me._groupOrderShareService.groupLink).svg()
    );
    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(
      () => {
        me.PushChanges();
      }
    );
    me.groupCode = me._inHouseOrderService.GroupCode;
    me.shownavigatetomenu = me._groupStateService.getshownavigatetomenu();
  }

  /** Share link*/
  //!MARK: No browser compatibility: Firefox and Webview Android
  public ShareLink() {
    const me = this;
    try {
      (navigator as any).share({
        url: me._groupOrderShareService.groupLink,
      });
    } catch (err) {
      me.OpenCopyLinkDialog();
    }
    me.inviteAFriend = false;
  }

  /** open qrCode dialog (zoom) */
  public OpenQRCodeDialog() {
    const me = this;
    me._bottomSheetHelperService.open(GroupOrderQrCodeDialogComponent, {
      data: me._groupOrderShareService.groupLink,
      autoFocus: false,
    });
    me.inviteAFriend = false;
  }

  public NavigateToMenu() {
    const me = this;
    if (me.inviteAFriend) {
      me.openAnnounceDialog();
    } else {
      me._router.navigate(['/menugroup']);
    }
  }

  /**Dialog: invite friends or put order*/
  public openAnnounceDialog() {
    const me = this;
    const warningDialog = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "phGroupOrder_InviteFriends_Dialog_Title"
        , content: "phGroupOrder_InviteFriends_Dialog_SubText"
        , firstBtnLabel: "phGroupOrder_InviteFriends_Dialog_OrderBtn"
        , secondBtnLabel: "phGroupOrder_InviteFriends_Dialog_InviteBtn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningDialog.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
        me._router.navigate(["/menugroup"]);
      } else if (result === AnounceModalResult.SecondButton) {
        me._router.navigate(["/groupOrderShare"]);
      } else {
        // nothing
      }
    });
  }

  public get InviteAFriend(): boolean {
    const me = this;
    return me.inviteAFriend;
  }

  public NavigateToLandingPage() {
    const me = this;
    me._router.navigate(["/groupOrderServiceSelector"]);
  }

  //! todo soll es so einen dialog geben?
  /** Warning dialog:Link expired  */
  public OpenWarningGroupIsFull() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(
      WarningdialogComponent,
      {
        data: {
          title: "phGroupOrder_GroupIsFull_Title",
          content: "phGroupOrder_GroupIsFull_SubText",
          btnLabel: "phGroupOrder_GroupIsFull_Btn",
        },
        panelClass: "mat-bottom-sheet-container-medium",
      }
    );
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/menuservice"]);
      }
    });
  }

  /** open copy link dialog if share not available */
  private OpenCopyLinkDialog() {
    const me = this;
    const copyLinkDialog = me._bottomSheetHelperService.open(
      SecureCheckDialogComponent,
      {
        data: {
          title: "phGroupOrder_Share_Link_NotAvailable_Title",
          description: "phGroupOrder_Share_Link_NotAvailable_Subtext",
          buttonTextAccept: "phGroupOrder_Share_Link_Copy_Btn",
          buttonTextDeny: "phGlobal_Continue",
          icon: "shop-icons.svg#ya-hypersoft-achtung",
        },
        panelClass: "mat-bottom-sheet-container-medium",
      }
    );
    copyLinkDialog.afterDismissed().subscribe((result) => {
      if (result) {
        if (window.isSecureContext) {
          // copy to clipboard only with secure origin https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
          window.navigator["clipboard"]
            .writeText(me._groupOrderShareService.groupLink)
            .then(() => {
              me._snackBarService.ShowMessage(
                snackBarMessageKey.copiedToClipboard,
                SnackBarMessageType.Successful
              );
            })
            .catch(() => {
              me._snackBarService.ShowErrorMessageFailed(126);
            });
        } else {
          me.copy(me._groupOrderShareService.groupLink);
          me._snackBarService.ShowMessage(
            snackBarMessageKey.copiedToClipboard,
            SnackBarMessageType.Successful
          );
        }
        me.setWebView();
      } else {
        // nothing
      }
    });
  }

  //workaround https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript/33928558#33928558
  private copy(text) {
    var input = document.createElement("textarea");
    input.innerHTML = text;
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand("copy");
    document.body.removeChild(input);
    return result;
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** navigate back */
  public navigateBack(): void {
    this._location.back();
  }
}
